import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  getIsLoading,
  setIsLoading,
  useAppSelector,
  useAppDispatch
} from 'app/redux';
import { LoadingSpinner } from 'app/components';
import styles from './APIView.module.scss';
import config from 'config';

export const APIView: React.FC = () => {
  const { api } = useParams();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(getIsLoading);
  const API_URL = config.APP.API;

  useEffect(() => {
    dispatch(setIsLoading(true));

    const apiIframe = document.getElementsByTagName('iframe')[0];
    apiIframe.addEventListener('load', () => dispatch(setIsLoading(false)));
  }, []);

  if (api === undefined) return <></>;

  return (
    <div className={styles['api-view']}>
      <iframe
        src={`${API_URL}/${api}/docs/`}
        title={`${api} API Documentation`}
      >
        <p>This browser does not support PDF!</p>
      </iframe>
      {isLoading && <LoadingSpinner />}
    </div>
  );
};

export default APIView;
